import logo from './logo.svg';
import './App.css';
import Products from './Component/Products/Products';
import Header from './Component/Header/Header';

function App() {
  return (
    <div className="App">
      <Header></Header>
      <Products></Products>
    </div>
  );
}

export default App;
